import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Card from '@components/Card';
import { getExpiredAtInfo } from '@helpers/dates';
import { useTranslation } from '@hooks';
import { CURRENCY_MAP } from '@constants/billing';

const CardText = styled('span')(({ isExpiredDate }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: isExpiredDate ? 'var(--error-main)' : 'var(--text-secondary)',
    marginTop: 0,
    marginBottom: '12px',
}));

const SubscriptionCard = ({ subscription = {}, selectedSubscription, setSubscription }) => {
    const { t } = useTranslation();
    const language = useSelector(state => state.auth.user?.language);

    const isExpiredDate = subscription?.billingDiffInDays < 0;
    const { expiredAt } = getExpiredAtInfo(subscription?.expiresAt, language);

    return (
        <Card
            type="radio"
            selected={subscription.id === selectedSubscription.id}
            title={subscription.stripeAccountName}
            value={subscription.id}
            setValue={setSubscription}
        >
            <CardText>
                {t('common.locations')} - {subscription.locationsCount}
            </CardText>
            <CardText>
                {t('SettingsGeneral.additionalUsers')} - {subscription.additionalUsersCount}
            </CardText>
            {subscription?.status !== 3 && (
                <CardText>
                    {t('SettingsGeneral.totalPrice')} - {CURRENCY_MAP[subscription?.currency]}
                    {subscription?.price}
                </CardText>
            )}
            {expiredAt && (
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <CardText>
                        {subscription?.status === 3
                            ? t('SettingsGeneral.cancelsOn')
                            : t('SettingsGeneral.nextPaymentOn')}
                        &nbsp;
                    </CardText>
                    <CardText isExpiredDate={isExpiredDate}>{expiredAt}</CardText>
                </div>
            )}
        </Card>
    );
};

export default SubscriptionCard;
